import 'jquery-scrollify';

$(function () {
  $.scrollify({
    section: ".view-full-screen1",
    interstitialSection: "",
    easing: "easeOutExpo",
    scrollSpeed: 1100,
    offset: 0,
    scrollbars: true,
    standardScrollElements: "",
    setHeights: true,
    overflowScroll: true,
    updateHash: false,
    touchScroll: true
  });
});

// Form hop tac
$(".show-popup-lp").click(function () {
  $("#lpbeamin-popup").show(300);
});

$(".close-lp-popup a").click(function () {
  $(".popup-lp-beamin").hide(300);
});

$(document).click(function (e) {
  if ((e.target.id === 'lpbeamin-popup')) {
    $(".popup-lp-beamin").hide("300");
  }
});



// WEBPACK FOOTER //
// ./src/ladipage.js